import { render } from "./TransitionFade.vue?vue&type=template&id=7f87fca0"
import script from "./TransitionFade.vue?vue&type=script&lang=js"
export * from "./TransitionFade.vue?vue&type=script&lang=js"

import "./TransitionFade.vue?vue&type=style&index=0&id=7f87fca0&lang=css"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__